export default "__VITE_PUBLIC_ASSET__768983e9__"